import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getWishlist, removeFromWishlist, clearWishlist, WishlistItem, addToCart } from '../../utils/cartUtils';
import OptimizedImage from '../OptimizedImage';
import './WishlistPage.css';

const WishlistPage: React.FC = () => {
  const [wishlistItems, setWishlistItems] = useState<WishlistItem[]>([]);

  useEffect(() => {
    setWishlistItems(getWishlist());
  }, []);

  const handleRemoveItem = (serviceId: string) => {
    removeFromWishlist(serviceId);
    setWishlistItems(getWishlist());
  };

  const handleClearWishlist = () => {
    clearWishlist();
    setWishlistItems([]);
  };

  const handleAddToCart = (item: WishlistItem) => {
    const cartItem = {
      id: item.id,
      name: item.name,
      price: item.price,
      image: item.image,
      category: item.category,
      duration: item.duration
    };
    addToCart(cartItem);
  };

  const handleMoveToCart = (item: WishlistItem) => {
    handleAddToCart(item);
    handleRemoveItem(item.id);
  };

  if (wishlistItems.length === 0) {
    return (
      <div className="wishlist-page">
        <div className="wishlist-container">
          <h1>Your Wishlist</h1>
          <div className="empty-wishlist">
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 21.35L10.55 20.03C5.4 15.36 2 12.28 2 8.5C2 5.42 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.09C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.42 22 8.5C22 12.28 18.6 15.36 13.45 20.04L12 21.35Z" fill="currentColor"/>
            </svg>
            <h2>Your wishlist is empty</h2>
            <p>Browse our puja services and save your favorites for later.</p>
            <Link to="/" className="continue-shopping-btn">
              Continue Shopping
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="wishlist-page">
      <div className="wishlist-container">
        <div className="wishlist-header">
          <h1>Your Wishlist ({wishlistItems.length} items)</h1>
          <button onClick={handleClearWishlist} className="clear-wishlist-btn">
            Clear Wishlist
          </button>
        </div>

        <div className="wishlist-grid">
          {wishlistItems.map((item) => (
            <div key={item.id} className="wishlist-item">
              <div className="item-image">
                <OptimizedImage src={item.image} alt={item.name} />
              </div>
              <div className="item-content">
                <div className="item-info">
                  <h3>{item.name}</h3>
                  <p className="item-category">{item.category}</p>
                  {item.duration && <p className="item-duration">Duration: {item.duration}</p>}
                  <div className="item-price">₹{item.price}</div>
                  <p className="item-added">Added {new Date(item.addedAt).toLocaleDateString()}</p>
                </div>
                <div className="item-actions">
                  <button 
                    onClick={() => handleMoveToCart(item)}
                    className="move-to-cart-btn"
                  >
                    Move to Cart
                  </button>
                  <button 
                    onClick={() => handleAddToCart(item)}
                    className="add-to-cart-btn"
                  >
                    Add to Cart
                  </button>
                  <button 
                    onClick={() => handleRemoveItem(item.id)}
                    className="remove-btn"
                  >
                    Remove
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WishlistPage;